<template>
  <loading
    :active.sync="$store.state.isLoading"
    :can-cancel="false"
    :is-full-page="false"/>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';

export default {
  components: {
    Loading,
  },
};
</script>
